import "@fontsource/poppins";
import "@fontsource/roboto";

const poppinsFont =
	'Poppins, "Times New Roman", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
const robotoFont =
	'Roboto, "Times New Roman", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

const fonts = {
	heading: poppinsFont,
	paragraphs: robotoFont,
	forms: robotoFont,
	buttons: robotoFont,
	links: robotoFont,
	body: robotoFont,
};

export default fonts;
